/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import moment from "moment";

import { LabelInfo } from "../../../components";

import {
  getFoto3x4,
  getDadosCivil,
  getIdt,
} from "../../../services/apiConsultaCivil";

import { IDadosCivil } from "../../../interface/civil";

interface Props {
  NumeroPessoa: string;
}

const styleInputs = {
  display: "flex",
  flexDirection: "row",
  gap: 1,
};

export const FichaCivil: React.FC = () => {
  const history = useHistory();
  const { params } = useRouteMatch<Props>();

  const [dados, setDados] = useState<IDadosCivil | null>(null);
  const [foto, setFoto] = useState("");
  const [fotoIdt, setFotoIdt] = useState("");
  const [loading, setLoading] = useState(true);
  const [msgError, setMsgErro] = useState("");
  const [msgEror, setMsgEro] = useState("");

  useEffect(() => {
    async function getFichaCivil() {
      await getDadosCivil(params.NumeroPessoa)
        .then((response) => {
          if (response.status === 200) {
            setDados(response.data[0]);
          }
          if (response.status === 400) {
            toast.error(`${response.data}`, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
            history.goBack();
          }
          if (response.status === 404) {
            toast.error("HOUVE ALGUM ERRO NA REQUISIÇÃO, TENTE NOVAMENTE.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
          }
          if (response.status === 500 || response.status === 503) {
            toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
          }
          if (response.status === 504) {
            toast.error(
              "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
          }
          setLoading(false);
        })
        .catch((err: any) => {
          setLoading(false);
          toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        });
    }
    getFichaCivil();
  }, []);

  useEffect(() => {
    async function getFoto() {
      await getFoto3x4(params.NumeroPessoa)
        .then((response) => {
          if (response.status === 200) {
            setFoto(response.data);
          }
          if (response.status === 404) {
            setMsgEro("Cadastro sem foto 3x4");
          }
          setLoading(false);
        })
        .catch((err: any) => {
          setLoading(false);
        });
    }
    getFoto();
  }, []);

  useEffect(() => {
    async function getFotoIdt() {
      await getIdt(params.NumeroPessoa).then((response) => {
        if (response.status === 200) {
          setFotoIdt(response.data[0].Imagem);
        }
        if (response.status === 404) {
          setMsgErro("Cadastro sem foto da identidade");
        }
      });
    }
    getFotoIdt();
  }, []);

  const imprimir = () => {
    window.print();
  };

  const voltar = () => {
    history.goBack();
  };

  const theme = MUI.useTheme();

  return (
    <MUI.Stack
      pt={[2, 0]}
      flexDirection="row"
      width="100%"
      height="80vh"
      overflow="auto"
      sx={{
        "@media print": {
          overflow: "hidden !important",
          height: "100%",
          pageBreakInside: "avoid",
        },
      }}
    >
      <MUI.Stack p={2} flex={1}>
        <MUI.Stack
          mb={1}
          gap={[1, 0]}
          width={["100%", "95%"]}
          flexDirection={["column", "row"]}
          justifyContent="space-between"
          sx={{
            displayPrint: "none",
          }}
        >
          <MUI.Button
            variant="contained"
            startIcon={<Icon.KeyboardReturn />}
            onClick={voltar}
          >
            Voltar para pesquisa
          </MUI.Button>
          <MUI.Button variant="contained" onClick={imprimir}>
            Imprimir
          </MUI.Button>
        </MUI.Stack>
        {!loading ? (
          <>
            {fotoIdt || foto ? (
              <MUI.Stack
                flex={1}
                mb={1}
                gap={3}
                alignItems="center"
                justifyContent={["center", "inherit"]}
                flexDirection={["column", "row"]}
                sx={{
                  "@media print": {
                    flexDirection: "row",
                  },
                }}
              >
                {fotoIdt && (
                  <MUI.Stack height="16rem">
                    <MUI.Avatar
                      imgProps={{
                        sx: {
                          width: "150px",
                          height: "200px",
                          objectFit: "fill",
                          "&:hover": {
                            width: "250px",
                            height: "270px",
                          },
                        },
                      }}
                      variant="rounded"
                      src={`data:image/jpeg;base64,${fotoIdt}`}
                      alt="foto identidade"
                      sx={{
                        width: "auto",
                        height: "265px",
                      }}
                    />
                  </MUI.Stack>
                )}
                {foto && (
                  <MUI.Stack maxHeight="10rem">
                    <MUI.Avatar
                      variant="rounded"
                      src={`data:image/jpeg;base64,${foto}`}
                      alt="foto 3x4"
                      sx={{
                        width: "150px",
                        height: "170px",
                      }}
                    />
                  </MUI.Stack>
                )}
              </MUI.Stack>
            ) : (
              false
            )}

            {dados && (
              <MUI.Stack width="97%">
                <MUI.Typography
                  bgcolor={theme.palette.secondary.light}
                  variant="h6"
                >
                  Ficha Cadastro Civil
                </MUI.Typography>
                <MUI.Divider
                  sx={{
                    borderWidth: 1.5,
                    backgroundColor: `${theme.palette.secondary.contrastText}`,
                  }}
                />
                <MUI.Grid container spacing={1} py={1}>
                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo label="Nome:" info={dados?.Nome} />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Mãe:"
                      info={dados?.Mae || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Pai:"
                      info={dados?.Pai || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Sexo:"
                      info={dados?.DescricaoSexo || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label=" Data Nascimento:"
                      info={
                        moment(dados?.DataNascimentoAproximado).format(
                          "DD/MM/YYYY HH:mm"
                        ) || "Não informado"
                      }
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label=" Número RG:"
                      info={dados?.RGAtribuido || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label=" Data de Expedição:"
                      info={
                        moment(dados?.DataIdentificacao).format(
                          "DD/MM/YYYY HH:mm"
                        ) || "Não informado"
                      }
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Profissão:"
                      info={dados?.NomeProfissao || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Grau de Instrução:"
                      info={dados?.DescricaoGrauInstrucao || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Número do PIS:"
                      info={dados?.PISPASEP || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Número do CPF:"
                      info={
                        dados?.Identificacao_CPF ||
                        dados?.CPF ||
                        "Não informado"
                      }
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="País de Nascimento:"
                      info={dados?.NomePaisNascimento || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Nacionalidade:"
                      info={dados?.DescricaoNacionalidade || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <MUI.Typography fontWeight="bold" variant="body1">
                      Natural de:
                    </MUI.Typography>
                    <MUI.Typography variant="body1">
                      {dados?.NomeMunicipioNascimento} /
                      {dados?.SiglaUFNascimento || "Não informado"}
                    </MUI.Typography>
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Telefones:"
                      info={dados?.Telefones || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Descrição tipo membro:"
                      info={dados?.DescricaoTipoMembro || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={12} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Antropometrias:"
                      info={dados?.Antropometrias || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} md={12} sm={12} item sx={styleInputs}>
                    <MUI.Typography fontWeight="bold" variant="body1">
                      Documento apresentado:
                    </MUI.Typography>
                    <MUI.Typography variant="body1">
                      {dados?.DocumentoApresentado || "Não informado"}
                    </MUI.Typography>
                  </MUI.Grid>

                  <MUI.Grid xs={12} md={12} sm={12} item sx={styleInputs}>
                    <MUI.Typography fontWeight="bold" variant="body1">
                      Endereço:
                    </MUI.Typography>
                    <MUI.Typography variant="body1">
                      {dados?.Enderecos || "Não informado"}
                    </MUI.Typography>
                  </MUI.Grid>
                </MUI.Grid>
              </MUI.Stack>
            )}
          </>
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </MUI.Stack>
  );
};
